/**
 * JWT Token specific types
 * Based on data model from specs/003-encoders-decoders-tools/data-model.md
 */

export const JwtAlgorithm = {
  HS256: 'HS256',
  HS384: 'HS384',
  HS512: 'HS512',
  RS256: 'RS256',
  RS384: 'RS384',
  RS512: 'RS512',
  ES256: 'ES256',
  ES384: 'ES384',
  ES512: 'ES512',
  PS256: 'PS256',
  PS384: 'PS384',
  PS512: 'PS512',
  NONE: 'none'
} as const;

export type JwtAlgorithm = typeof JwtAlgorithm[keyof typeof JwtAlgorithm];

export interface JWTToken {
  id: string;
  rawToken: string;
  parsedData?: {
    header: JWTPayload;
    payload: JWTPayload;
    signature: string;
  };
  validationStatus?: {
    isValid: boolean;
    isExpired: boolean;
    errorMessage?: string;
    expiresAt?: Date;
  };
  decodedAt: Date;
  generatedSecret?: string;
}

export interface JWTPayload {
  alg?: string;
  typ?: string;
  iss?: string;
  sub?: string;
  aud?: string[];
  exp?: number;
  iat?: number;
  nbf?: number;
  jti?: string;
  [key: string]: any;
}

export interface JwtValidationResult {
  isValid: boolean;
  isExpired: boolean;
  errorMessage?: string;
  expiresAt?: Date;
}

export interface JwtSecurityWarning {
  type: 'secret-storage' | 'client-side' | 'expiration';
  message: string;
  severity: 'info' | 'warning' | 'error';
}

export interface JwtTokenConfiguration {
  algorithm: JwtAlgorithm;
  secret: string;
  payload?: Record<string, any>;
  expiresIn?: string;
  issuer?: string;
  audience?: string;
}